"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Glyphicon = _interopRequireDefault(require("react-bootstrap/lib/Glyphicon"));

var _xor = _interopRequireDefault(require("lodash/xor"));

var _uncontrollable = require("uncontrollable");

var _templateObject,
    _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Foo = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding-left: 5px;\n  ::first-letter {\n    text-transform: capitalize;\n  }\n"])));

var _FilterOption = function _FilterOption(_ref) {
  var name = _ref.name,
      allValues = _ref.allValues,
      currentValues = _ref.currentValues,
      isOpen = _ref.isOpen,
      onChangeIsOpen = _ref.onChangeIsOpen,
      onChangeCurrentValues = _ref.onChangeCurrentValues;
  var allChecked = allValues.every(function (v) {
    return currentValues.includes(v);
  });
  var allUnchecked = allValues.every(function (v) {
    return !currentValues.includes(v);
  });
  var openable = allValues.length !== 1 || allValues[0] !== name;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    style: {
      margin: "10px 0 0 "
    },
    value: name,
    onChange: onChangeCurrentValues.bind(_this, (0, _xor["default"])(allValues, currentValues).length ? allValues : []),
    checked: allChecked,
    ref: function ref(checkbox) {
      checkbox ? checkbox.indeterminate = !allChecked && !allUnchecked : null;
    }
  }), /*#__PURE__*/_react["default"].createElement(Foo, {
    onClick: openable ? onChangeIsOpen.bind(_this, !isOpen) : function () {},
    href: "#"
  }, name, " ", openable && /*#__PURE__*/_react["default"].createElement(_Glyphicon["default"], {
    style: {
      fontSize: "x-small",
      paddingLeft: "5px"
    },
    glyph: isOpen ? "menu-up" : "menu-down"
  })), openable && isOpen && /*#__PURE__*/_react["default"].createElement("div", null, allValues.map(function (value) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: value,
      style: {
        marginLeft: "20px",
        fontSize: "smaller"
      }
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "checkbox",
      value: value,
      onChange: onChangeCurrentValues.bind(_this, (0, _xor["default"])([value], currentValues)),
      checked: currentValues.includes(value),
      style: {
        margin: "0"
      }
    }), /*#__PURE__*/_react["default"].createElement("span", null, " ", value));
  })));
};

_FilterOption.propTypes = {
  name: _propTypes["default"].string.isRequired,
  allValues: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  currentValues: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  onChangeCurrentValues: _propTypes["default"].func.isRequired,
  isOpen: _propTypes["default"].bool.isRequired,
  onChangeIsOpen: _propTypes["default"].func.isRequired
};
var FilterOption = (0, _uncontrollable.uncontrollable)(_FilterOption, {
  isOpen: "onChangeIsOpen"
});
FilterOption.defaultProps = {
  defaultIsOpen: false
};
var _default = FilterOption;
exports["default"] = _default;